import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Box, Button, Grid } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import * as React from "react";
import { connect } from "react-redux";
import AttachFile from "../../components/Comman/AttachFile";
import { LabelCompo } from "../../components/Comman/Label";
import endpoint from "../../config/endpoints";
import {
    errorAtValidationMsg,
    importTxt,
    noInternetMsg,
    selectExcelFileMsg,
    serverMsg,
    validatedSuccessfullyMsg,
} from "../../config/messageconstant";
import { apiPostForImage } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import TypographyCompo from "../../components/Comman/TypographyCompo";
import { aliceBlueColor, blackPantherColor, checkboxColor, figmaTitleColor, melonColor, redShadowColor, SeashellColor, stoneColdGrayColor, strongRedColor, warmPinkColor, white } from "../../config/ColorObj";

// ─── Styles ────────────────────────────────────────────────────────────────────

const styles = {
    dialog: {
        width: "70%",
        borderRadius: "12px",
    },
    dialogContent: {
        backgroundColor: aliceBlueColor,
    },
    outerGrid: {
        alignItems: "flex-start",
        flexWrap: { xs: "wrap", md: "nowrap" },
    },
    contentBox: {
        display: "flex",
        flexDirection: "column",
        gap: 1,
        padding: "10px 5px 10px 5px",
        justifyContent: "flex-start",
    },
    labelRow: {
        display: "flex",
        alignItems: "center",
        gap: 2,
    },
    labelInner: {
        display: "flex",
        alignItems: "center",
    },
    asteriskLabel: {
        fontSize: 18,
        fontWeight: 500,
        color: strongRedColor,
    },
    selectFileLabel: {
        fontSize: 17,
        fontWeight: 450,
        color: blackPantherColor,
        whiteSpace: "nowrap",
    },
    attachFileBox: {
        display: "flex",
        alignItems: "center",
        flexGrow: 1,
    },
    fileNameRow: {
        display: "flex",
        alignItems: "center",
    },
    fileNameText: {
        fontSize: 17,
        fontWeight: 400,
        wordWrap: "break-word",
        overflowWrap: "break-word",
        whiteSpace: "normal",
        maxWidth: "800px",
        flex: "1 1 auto",
        color: figmaTitleColor,
        cursor: "pointer",
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline",
        },
    },
    actionGrid: {
        alignItems: "center",
        display: "flex",
        justifyContent: "flex-end",
    },
    hintTextGrid: {
        display: "flex",
        justifyContent: "flex-start",
    },
    hintText: {
        fontSize: "14px",
        color: stoneColdGrayColor,
        textAlign: "right",
    },
    actionButtonsGrid: {
        display: "flex",
        justifyContent: "flex-end",
    },
    actionButtonsBox: {
        display: "flex",
        gap: 1,
        justifyContent: "flex-end",
    },
    clearButton: {
        borderRadius: 2,
        textTransform: "none",
        fontWeight: 600,
        minWidth: "120px",
        height: "35px",
        borderColor: melonColor,
        color: strongRedColor,
        backgroundColor: SeashellColor,
        boxShadow: "0 3px 6px rgba(248, 248, 248, 0.1)",
        transition: "all 0.3s ease",
        "&:hover": {
            backgroundColor: warmPinkColor,
            borderColor: strongRedColor,
            color: redShadowColor,
            transform: "translateY(-2px)",
            boxShadow: "0 6px 12px rgba(248, 248, 248, 0.2)",
        },
    },
    validateButton: {
        color: white,
        borderRadius: 2,
        textTransform: "none",
        fontWeight: 600,
        transition: "all 0.2s",
        minWidth: "150px",
        height: "35px",
        "&:hover": {
            backgroundColor: checkboxColor,
            transform: "translateY(-2px)",
        },
    },
    closeIconButton: {
        position: "absolute",
        right: 8,
        top: 8,
        color: (theme) => theme.palette.grey[500],
    },
    uploadIcon: {
        color: white,
    },
};

// ─── Styled Components ─────────────────────────────────────────────────────────

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={styles.closeIconButton}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const ImportOutletEnquiryPopUp = ({
    handleCloses,
    open,
    showNotification,
    showLoador,
    dataMethod,
}) => {
    const [fileName, setFileName] = React.useState("");

    const handleClose = React.useCallback(() => {
        handleCloses();
    }, [handleCloses]);

    const changeH = React.useCallback((fileName) => {
        setFileName(fileName);
    }, []);

    const onClickViewPreview = React.useCallback((e, row) => {
        e.stopPropagation();
        const url = URL.createObjectURL(row);
        window.open(url);
    }, []);

    const onClearHandler = React.useCallback(() => {
        setFileName("");
    }, []);

    const validatedOutletEnquiryMethod = React.useCallback(
        (dataObj) => {
            dataMethod(dataObj);
        },
        [dataMethod]
    );

    const onValidate = React.useCallback(async () => {
        if (!navigator.onLine) {
            showNotification({ msg: noInternetMsg, severity: "error" });
            return;
        }

        const formData = new FormData();
        formData.append("dataExcel", fileName);

        showLoador({ loador: true });
        await apiPostForImage({
            url: endpoint.importData + "/validate-enquiry-master-data-sheet",
            postBody: formData,
        }).then(({ data, success }) => {
            if (success) {
                if (data && data.data) {
                    if (data.error) {
                        showNotification({ msg: data.data.errorMessage, severity: "error" });
                    } else {
                        const hasErrorRow = data.data.recordList.some((item) => item.flag == 1);
                        showNotification(
                            hasErrorRow
                                ? { msg: errorAtValidationMsg, severity: "error" }
                                : { msg: validatedSuccessfullyMsg }
                        );
                    }
                    validatedOutletEnquiryMethod(data.data.recordList);
                    handleClose();
                }
            } else {
                showNotification({ msg: serverMsg, severity: "error" });
            }
        });
        showLoador({ loador: false });
    }, [fileName, showLoador, showNotification, validatedOutletEnquiryMethod, handleClose]);

    const isFileSelected = React.useMemo(() => fileName !== "", [fileName]);

    return (
        <BootstrapDialog
            aria-labelledby="customized-dialog-title"
            open={open}
            fullWidth
            maxWidth="sm"
            PaperProps={{ sx: styles.dialog }}
        >
            <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                {importTxt}
            </BootstrapDialogTitle>

            <DialogContent dividers sx={styles.dialogContent}>
                <Grid container xs={12} sm={12} md={12} spacing={0.5} sx={styles.outerGrid}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Box sx={styles.contentBox}>
                            {/* Label + File Input Row */}
                            <Box sx={styles.labelRow}>
                                {!isFileSelected && (
                                    <>
                                        <Box sx={styles.labelInner}>
                                            <LabelCompo
                                                className="text-black"
                                                style={styles.asteriskLabel}
                                                label={"*"}
                                            />
                                            <LabelCompo
                                                className="text-black"
                                                style={styles.selectFileLabel}
                                                label={"Select Excel File :"}
                                            />
                                        </Box>
                                        <Box sx={styles.attachFileBox}>
                                            <AttachFile
                                                name={"file"}
                                                fileName={changeH}
                                                sx={{ flexGrow: 1, minWidth: 0 }}
                                            />
                                        </Box>
                                    </>
                                )}
                            </Box>

                            {/* File Name Preview Row */}
                            {isFileSelected && (
                                <Box sx={styles.fileNameRow}>
                                    <TypographyCompo
                                        variant="body2"
                                        onClick={(e) => onClickViewPreview(e, fileName)}
                                        sx={styles.fileNameText}
                                    >
                                        {fileName.name}
                                    </TypographyCompo>
                                </Box>
                            )}
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogContent dividers>
                <Grid container xs={12} sm={12} md={12} spacing={1} sx={styles.actionGrid}>
                    {!isFileSelected && (
                        <Grid item xs={12} sm={12} md={12} lg={12} sx={styles.hintTextGrid}>
                            <TypographyCompo variant="body2" sx={styles.hintText}>
                                {selectExcelFileMsg}
                            </TypographyCompo>
                        </Grid>
                    )}

                    {isFileSelected && (
                        <Grid item xs={12} sm={12} md={12} lg={12} sx={styles.actionButtonsGrid}>
                            <Box sx={styles.actionButtonsBox}>
                                <Button
                                    variant="outlined"
                                    size="medium"
                                    startIcon={<ClearIcon />}
                                    sx={styles.clearButton}
                                    onClick={onClearHandler}
                                >
                                    Clear
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="medium"
                                    startIcon={<CloudUploadIcon sx={styles.uploadIcon} />}
                                    sx={styles.validateButton}
                                    onClick={onValidate}
                                >
                                    Validate
                                </Button>
                            </Box>
                        </Grid>
                    )}
                </Grid>
            </DialogContent>
        </BootstrapDialog>
    );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
    showNotification,
    showLoador,
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportOutletEnquiryPopUp);